import {
  BodySizeData,
  MeasurementGuidesMap,
  SizeConfigMap,
  SizeDataMap,
} from '@/types/size'

export const PRODUCT_SIZE: Record<string, string> = {
  '67ac49a470b8511ed6c7710d': 'BRA',
  '67ac512f70b8511ed6c77113': 'LEGGING',
  '67ac574570b8511ed6c7711d': 'SHIRT',
  '67c03249d0a61fdaefc2cf13': 'SHORTS',
  '684f7891d1de2819b1a0b1b8': 'DRESS',
  '68f5da7b27f15f0c5c12f2be': 'FEMALE_PANTS',
  '691fd178b11a865d5b0b683b': 'FEMALE_ACCESSORIES',

  //size nam
  '69046f19235d0101aa3c1151': 'SHIRT',
  '6904700e235d0101aa3c1153': 'SHORTS',
  '6904700e235d0101aa3c1154': 'MALE_PANTS',
  '6904700f235d0101aa3c1155': 'JEANS',
  '69047010235d0101aa3c1156': 'UNDERWEAR',
  '69047010235d0101aa3c1157': 'JACKET',
  '691be073e23ee3205b5e2dd0': 'MALE_ACCESSORIES',

  '6a0ebdabae4ebe63f9060bc2': 'MALE_OTHER',
  '6a0ebe6eae4ebe63f9060bc3': 'FEMALE_OTHER',
  '6a0ebeb0ae4ebe63f9060bc4': 'KID_OTHER',
  '6a0ebfa2ae4ebe63f9060bc5': 'UNISEX_OTHER',
}

// Data cho hướng dẫn chọn độ dài Legging
export const LEGGING_LENGTH_GUIDE = {
  title: 'product_detail.size_chart.constants.legging_length_guide.title',
  rows: [
    {
      name: 'product_detail.size_chart.constants.legging_length_guide.row_name',
      id: 1,
    },
  ],
  columns: [
    {
      name: 'product_detail.size_chart.constants.legging_length_guide.columns.full',
      id: 1,
    },
    {
      name: 'product_detail.size_chart.constants.legging_length_guide.columns.seven_eight',
      id: 2,
    },
    {
      name: 'product_detail.size_chart.constants.legging_length_guide.columns.capri',
      id: 3,
    },
  ],
  headerRow:
    'product_detail.size_chart.constants.legging_length_guide.header_row',
  matrix: [
    { rowId: 1, columnId: 1, value: '69 - 71' },
    { rowId: 1, columnId: 2, value: '61 - 63' },
    { rowId: 1, columnId: 3, value: '52.5 - 53.5' },
  ],
  descriptions: [
    {
      type: 'Full length',
      description:
        'product_detail.size_chart.constants.legging_length_guide.descriptions.full_length',
    },
    {
      type: 'Dài 7/8',
      description:
        'product_detail.size_chart.constants.legging_length_guide.descriptions.seven_eight_length',
    },
    {
      type: 'Capri',
      description:
        'product_detail.size_chart.constants.legging_length_guide.descriptions.capri_length',
    },
  ],
  note: 'product_detail.size_chart.constants.legging_length_guide.note',
}

export const SIZE_DATA: SizeDataMap = {
  BRA: {
    rows: [
      {
        name: '65-68',
        id: 1,
      },
      {
        name: '69-73',
        id: 2,
      },
      {
        name: '74-78',
        id: 3,
      },
      {
        name: '79-83',
        id: 4,
      },
      {
        name: '84-87',
        id: 5,
      },
    ],
    columns: [
      {
        name: '75-81',
        id: 1,
      },
      {
        name: '82-85',
        id: 2,
      },
      {
        name: '86-90',
        id: 3,
      },
      {
        name: '91-95',
        id: 4,
      },
      {
        name: '96-100',
        id: 5,
      },
    ],
    headerTitle: 'size_chart.constants.size_labels.bust',
    leftTitle: 'size_chart.constants.size_labels.underbust',
    matrix: [
      { rowId: 1, columnId: 1, value: 'XS' },
      { rowId: 2, columnId: 1, value: 'XS' },
      { rowId: 1, columnId: 2, value: 'XS' },
      { rowId: 2, columnId: 2, value: 'S' },
      { rowId: 3, columnId: 2, value: 'S' },
      { rowId: 1, columnId: 3, value: 'S' },
      { rowId: 2, columnId: 3, value: 'S' },
      { rowId: 3, columnId: 3, value: 'M' },
      { rowId: 4, columnId: 3, value: 'L' },
      { rowId: 2, columnId: 4, value: 'M' },
      { rowId: 3, columnId: 4, value: 'M' },
      { rowId: 4, columnId: 4, value: 'L' },
      { rowId: 5, columnId: 4, value: 'L' },
      { rowId: 3, columnId: 5, value: 'L' },
      { rowId: 4, columnId: 5, value: 'XL' },
      { rowId: 5, columnId: 5, value: 'XL' },
    ],
  },
  LEGGING: {
    rows: [
      {
        name: '80-84',
        id: 1,
      },
      {
        name: '85-89',
        id: 2,
      },
      {
        name: '90-94',
        id: 3,
      },
      {
        name: '95-99',
        id: 4,
      },
      {
        name: '100-104',
        id: 5,
      },
    ],
    columns: [
      {
        name: '58-64',
        id: 1,
      },
      {
        name: '65-71',
        id: 2,
      },
      {
        name: '72-77',
        id: 3,
      },
      {
        name: '78-85',
        id: 4,
      },
      {
        name: '86-94',
        id: 5,
      },
    ],
    headerTitle: 'size_chart.constants.size_labels.waist',
    leftTitle: 'size_chart.constants.size_labels.hips',
    matrix: [
      { rowId: 1, columnId: 1, value: 'XS' },
      { rowId: 2, columnId: 1, value: 'XS' },
      { rowId: 3, columnId: 1, value: 'S' },
      { rowId: 4, columnId: 1, value: 'S' },
      { rowId: 1, columnId: 2, value: 'XS' },
      { rowId: 2, columnId: 2, value: 'S' },
      { rowId: 3, columnId: 2, value: 'S' },
      { rowId: 4, columnId: 2, value: 'M' },
      { rowId: 5, columnId: 2, value: 'M' },
      { rowId: 1, columnId: 3, value: 'S' },
      { rowId: 2, columnId: 3, value: 'M' },
      { rowId: 3, columnId: 3, value: 'M' },
      { rowId: 4, columnId: 3, value: 'M' },
      { rowId: 5, columnId: 3, value: 'L' },
      { rowId: 2, columnId: 4, value: 'M' },
      { rowId: 3, columnId: 4, value: 'L' },
      { rowId: 4, columnId: 4, value: 'L' },
      { rowId: 5, columnId: 4, value: 'XL' },
      { rowId: 3, columnId: 5, value: 'L' },
      { rowId: 4, columnId: 5, value: 'XL' },
      { rowId: 5, columnId: 5, value: 'XL' },
    ],
  },
}

export const MEASUREMENT_GUIDES: MeasurementGuidesMap = {
  BRA: {
    video: {
      url: 'https://media3.coolmate.me/uploads/videos/chon-size-bra-abc.mp4',
      thumbnail:
        'https://media3.coolmate.me/uploads/videos/chon-size-bra-abc.mp4',
    },
    steps: [
      {
        image: '/image/March2025/mceclip0_23.png',
        title:
          'product_detail.size_chart.constants.measurement_guides.bra.steps.step1.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.bra.steps.step1.description',
      },
      {
        image: '/image/March2025/mceclip1_2.png',
        title:
          'product_detail.size_chart.constants.measurement_guides.bra.steps.step2.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.bra.steps.step2.description',
      },
      {
        image: '/image/March2025/mceclip2_77.png',
        title:
          'product_detail.size_chart.constants.measurement_guides.bra.steps.step3.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.bra.steps.step3.description',
      },
    ],
    measurementPoints: [
      {
        number: 1,
        title:
          'product_detail.size_chart.constants.measurement_guides.bra.measurement_points.bust.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.bra.measurement_points.bust.description',
      },
      {
        number: 2,
        title:
          'product_detail.size_chart.constants.measurement_guides.bra.measurement_points.underbust.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.bra.measurement_points.underbust.description',
      },
    ],
    illustration: '/image/March2025/mceclip1_33.png',
  },
  LEGGING: {
    video: {
      url: 'https://media3.coolmate.me/uploads/videos/chon-size-quan-abc.mp4',
      thumbnail:
        'https://media3.coolmate.me/uploads/videos/chon-size-quan-abc.mp4',
    },
    steps: [
      {
        image: '/image/March2025/mceclip0_81.png',
        title:
          'product_detail.size_chart.constants.measurement_guides.legging.steps.step1.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.legging.steps.step1.description',
      },
      {
        image: '/image/March2025/mceclip2_86.png',
        title:
          'product_detail.size_chart.constants.measurement_guides.legging.steps.step2.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.legging.steps.step2.description',
      },
      {
        image: '/image/March2025/mceclip1_72.png',
        title:
          'product_detail.size_chart.constants.measurement_guides.legging.steps.step3.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.legging.steps.step3.description',
      },
      {
        image: '/image/March2025/mceclip3_76.png',
        title:
          'product_detail.size_chart.constants.measurement_guides.legging.steps.step4.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.legging.steps.step4.description',
      },
    ],
    measurementPoints: [
      {
        number: 1,
        title:
          'product_detail.size_chart.constants.measurement_guides.legging.measurement_points.waist.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.legging.measurement_points.waist.description',
      },
      {
        number: 2,
        title:
          'product_detail.size_chart.constants.measurement_guides.legging.measurement_points.hips.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.legging.measurement_points.hips.description',
      },
      {
        number: 3,
        title:
          'product_detail.size_chart.constants.measurement_guides.legging.measurement_points.inner_length.title',
        description:
          'product_detail.size_chart.constants.measurement_guides.legging.measurement_points.inner_length.description',
      },
    ],
    illustration: '/image/March2025/mceclip0_47.png',
  },
}

export const SIZE_CONFIG: SizeConfigMap = {
  BRA: {
    xAxis: 'bust',
    yAxis: 'underbust',
    xAxisLabel: 'product_detail.size_chart.constants.size_labels.chest',
    yAxisLabel: 'product_detail.size_chart.constants.size_labels.underbust',
    minXAxis: 78,
    maxXAxis: 100,
    minYAxis: 65,
    maxYAxis: 87,
    unitX: 'cm',
    unitY: 'cm',
  },
  LEGGING: {
    xAxis: 'waist',
    yAxis: 'hips',
    xAxisLabel:
      'product_detail.size_chart.constants.size_labels.waist_measurement',
    yAxisLabel:
      'product_detail.size_chart.constants.size_labels.hips_measurement',
    minXAxis: 58,
    maxXAxis: 94,
    minYAxis: 80,
    maxYAxis: 104,
    unitX: 'cm',
    unitY: 'cm',
  },
}

const heightWeightConfig = {
  xAxis: 'height',
  yAxis: 'weight',
  xAxisLabel: 'product_detail.size_chart.constants.size_labels.height',
  yAxisLabel: 'product_detail.size_chart.constants.size_labels.weight',
  minXAxis: 145,
  maxXAxis: 175,
  minYAxis: 40,
  maxYAxis: 65,
  unitX: 'cm',
  unitY: 'kg',
}

SIZE_CONFIG.SHIRT = heightWeightConfig
SIZE_CONFIG.PANTS = heightWeightConfig
SIZE_CONFIG.SHORTS = heightWeightConfig
SIZE_CONFIG.DRESS = heightWeightConfig
SIZE_CONFIG.FEMALE_PANTS = heightWeightConfig
SIZE_CONFIG.MALE_ACCESSORIES = heightWeightConfig

export const BODY_SIZE: BodySizeData = {
  rows: [
    {
      name: 'product_detail.size_chart.constants.size_labels.chest_measurement',
      id: 1,
    },
    {
      name: 'product_detail.size_chart.constants.size_labels.waist_measurement_short',
      id: 2,
    },
    {
      name: 'product_detail.size_chart.constants.size_labels.hips_measurement_short',
      id: 3,
    },
    {
      name: 'product_detail.size_chart.constants.size_labels.reference_weight',
      id: 4,
    },
  ],
  columns: [
    {
      name: 'XS',
      id: 1,
    },
    {
      name: 'S',
      id: 2,
    },
    {
      name: 'M',
      id: 3,
    },
    {
      name: 'L',
      id: 4,
    },
    {
      name: 'XL',
      id: 5,
    },
  ],
  matrix: [
    {
      rowId: 1,
      columnId: 1,
      value: '75~81',
    },
    {
      rowId: 1,
      columnId: 2,
      value: '82~85',
    },
    {
      rowId: 1,
      columnId: 3,
      value: '86~90',
    },
    {
      rowId: 1,
      columnId: 4,
      value: '91~95',
    },
    {
      rowId: 1,
      columnId: 5,
      value: '96~100',
    },
    {
      rowId: 2,
      columnId: 1,
      value: '58~64',
    },
    {
      rowId: 2,
      columnId: 2,
      value: '65~71',
    },
    {
      rowId: 2,
      columnId: 3,
      value: '72~77',
    },
    {
      rowId: 2,
      columnId: 4,
      value: '78~85',
    },
    {
      rowId: 2,
      columnId: 5,
      value: '86~94',
    },
    {
      rowId: 3,
      columnId: 1,
      value: '80~84',
    },
    {
      rowId: 3,
      columnId: 2,
      value: '85~89',
    },
    {
      rowId: 3,
      columnId: 3,
      value: '90~94',
    },
    {
      rowId: 3,
      columnId: 4,
      value: '95~99',
    },
    {
      rowId: 3,
      columnId: 5,
      value: '100~104',
    },
    {
      rowId: 4,
      columnId: 1,
      value: '40~45',
    },
    {
      rowId: 4,
      columnId: 2,
      value: '45~50',
    },
    {
      rowId: 4,
      columnId: 3,
      value: '50~55',
    },
    {
      rowId: 4,
      columnId: 4,
      value: '55~60',
    },
    {
      rowId: 4,
      columnId: 5,
      value: '60~65',
    },
  ],
}

export const SIZE_DATA_OLD = {
  BRA: {
    title: 'product_detail.size_chart.constants.size_tables.bra',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'size_data_old.bra.rows.cup' },
      { id: 2, name: 'size_data_old.bra.rows.bust' },
      { id: 3, name: 'size_data_old.bra.rows.underbust' },
      { id: 4, name: 'size_data_old.bra.rows.weight_reference' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: 'B' },
      { rowId: 1, columnId: 2, value: 'B' },
      { rowId: 1, columnId: 3, value: 'B' },
      { rowId: 1, columnId: 4, value: 'B' },
      { rowId: 1, columnId: 5, value: 'B' },
      { rowId: 2, columnId: 1, value: '75-81' },
      { rowId: 2, columnId: 2, value: '82-85' },
      { rowId: 2, columnId: 3, value: '86-90' },
      { rowId: 2, columnId: 4, value: '91-95' },
      { rowId: 2, columnId: 5, value: '96-100' },
      { rowId: 3, columnId: 1, value: '65-68' },
      { rowId: 3, columnId: 2, value: '69-73' },
      { rowId: 3, columnId: 3, value: '74-78' },
      { rowId: 3, columnId: 4, value: '79-83' },
      { rowId: 3, columnId: 5, value: '84-87' },
      { rowId: 4, columnId: 1, value: '40-45' },
      { rowId: 4, columnId: 2, value: '45-50' },
      { rowId: 4, columnId: 3, value: '50-55' },
      { rowId: 4, columnId: 4, value: '55-60' },
      { rowId: 4, columnId: 5, value: '60-65' },
    ],
  },
  LEGGING: {
    title: 'product_detail.size_chart.constants.size_tables.legging',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'size_data_old.legging.rows.international_conversion' },
      { id: 2, name: 'size_data_old.legging.rows.waist' },
      { id: 3, name: 'size_data_old.legging.rows.hips' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '0-2' },
      { rowId: 1, columnId: 2, value: '4-6' },
      { rowId: 1, columnId: 3, value: '8-10' },
      { rowId: 1, columnId: 4, value: '12-14' },
      { rowId: 1, columnId: 5, value: '16-18' },
      { rowId: 2, columnId: 1, value: '58-64' },
      { rowId: 2, columnId: 2, value: '65-71' },
      { rowId: 2, columnId: 3, value: '72-77' },
      { rowId: 2, columnId: 4, value: '78-85' },
      { rowId: 2, columnId: 5, value: '86-94' },
      { rowId: 3, columnId: 1, value: '80-84' },
      { rowId: 3, columnId: 2, value: '85-89' },
      { rowId: 3, columnId: 3, value: '90-94' },
      { rowId: 3, columnId: 4, value: '95-99' },
      { rowId: 3, columnId: 5, value: '100-104' },
    ],
  },
  SHIRT: {
    title: 'product_detail.size_chart.constants.size_tables.shirt',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'size_data_old.shirt.rows.chest' },
      { id: 2, name: 'size_data_old.shirt.rows.waist' },
      { id: 3, name: 'size_data_old.shirt.rows.hips' },
      { id: 4, name: 'size_data_old.shirt.rows.weight' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '75-81' },
      { rowId: 1, columnId: 2, value: '82-85' },
      { rowId: 1, columnId: 3, value: '86-90' },
      { rowId: 1, columnId: 4, value: '91-95' },
      { rowId: 1, columnId: 5, value: '96-100' },
      { rowId: 2, columnId: 1, value: '58-64' },
      { rowId: 2, columnId: 2, value: '65-71' },
      { rowId: 2, columnId: 3, value: '72-77' },
      { rowId: 2, columnId: 4, value: '78-85' },
      { rowId: 2, columnId: 5, value: '86-94' },
      { rowId: 3, columnId: 1, value: '80-84' },
      { rowId: 3, columnId: 2, value: '85-89' },
      { rowId: 3, columnId: 3, value: '90-94' },
      { rowId: 3, columnId: 4, value: '95-99' },
      { rowId: 3, columnId: 5, value: '100-104' },
      { rowId: 4, columnId: 1, value: '40-45' },
      { rowId: 4, columnId: 2, value: '45-50' },
      { rowId: 4, columnId: 3, value: '50-55' },
      { rowId: 4, columnId: 4, value: '55-60' },
      { rowId: 4, columnId: 5, value: '60-65' },
    ],
  },
  PANTS: {
    title: 'product_detail.size_chart.constants.size_tables.pants',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'size_data_old.pants.rows.waist' },
      { id: 2, name: 'size_data_old.pants.rows.hips' },
      { id: 3, name: 'size_data_old.pants.rows.inner_length' },
      { id: 4, name: 'size_data_old.pants.rows.weight' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '58-64' },
      { rowId: 1, columnId: 2, value: '65-71' },
      { rowId: 1, columnId: 3, value: '72-77' },
      { rowId: 1, columnId: 4, value: '78-85' },
      { rowId: 1, columnId: 5, value: '86-94' },
      { rowId: 2, columnId: 1, value: '80-84' },
      { rowId: 2, columnId: 2, value: '85-89' },
      { rowId: 2, columnId: 3, value: '90-94' },
      { rowId: 2, columnId: 4, value: '95-99' },
      { rowId: 2, columnId: 5, value: '100-104' },
      { rowId: 3, columnId: 1, value: '72' },
      { rowId: 3, columnId: 2, value: '73' },
      { rowId: 3, columnId: 3, value: '74' },
      { rowId: 3, columnId: 4, value: '74.5' },
      { rowId: 3, columnId: 5, value: '75 ' },
      { rowId: 4, columnId: 1, value: '40-45' },
      { rowId: 4, columnId: 2, value: '45-50' },
      { rowId: 4, columnId: 3, value: '50-55' },
      { rowId: 4, columnId: 4, value: '55-60' },
      { rowId: 4, columnId: 5, value: '60-65' },
    ],
  },
  SHORTS: {
    title: 'product_detail.size_chart.constants.size_tables.shorts',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'size_data_old.shorts.rows.waist' },
      { id: 2, name: 'size_data_old.shorts.rows.hips' },
      { id: 3, name: 'size_data_old.shorts.rows.weight' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '58-64' },
      { rowId: 1, columnId: 2, value: '65-71' },
      { rowId: 1, columnId: 3, value: '72-77' },
      { rowId: 1, columnId: 4, value: '78-85' },
      { rowId: 1, columnId: 5, value: '86-94' },
      { rowId: 2, columnId: 1, value: '80-84' },
      { rowId: 2, columnId: 2, value: '85-89' },
      { rowId: 2, columnId: 3, value: '90-94' },
      { rowId: 2, columnId: 4, value: '95-99' },
      { rowId: 2, columnId: 5, value: '100-104' },
      { rowId: 3, columnId: 1, value: '40-45' },
      { rowId: 3, columnId: 2, value: '45-50' },
      { rowId: 3, columnId: 3, value: '50-55' },
      { rowId: 3, columnId: 4, value: '55-60' },
      { rowId: 3, columnId: 5, value: '60-65' },
    ],
  },
  DRESS: {
    title: 'product_detail.size_chart.constants.size_tables.dress',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'size_data_old.dress.rows.waist' },
      { id: 2, name: 'size_data_old.dress.rows.hips' },
      { id: 3, name: 'size_data_old.dress.rows.weight' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '58-64' },
      { rowId: 1, columnId: 2, value: '65-71' },
      { rowId: 1, columnId: 3, value: '72-77' },
      { rowId: 1, columnId: 4, value: '78-85' },
      { rowId: 1, columnId: 5, value: '86-94' },
      { rowId: 2, columnId: 1, value: '80-84' },
      { rowId: 2, columnId: 2, value: '85-89' },
      { rowId: 2, columnId: 3, value: '90-94' },
      { rowId: 2, columnId: 4, value: '95-99' },
      { rowId: 2, columnId: 5, value: '100-104' },
      { rowId: 3, columnId: 1, value: '40-45' },
      { rowId: 3, columnId: 2, value: '45-50' },
      { rowId: 3, columnId: 3, value: '50-55' },
      { rowId: 3, columnId: 4, value: '55-60' },
      { rowId: 3, columnId: 5, value: '60-65' },
    ],
  },
  FEMALE_PANTS: {
    headerTitle: 'size_data_old.pants.header_title',
    leftTitle: 'size_data_old.pants.left_title',
    columns: [
      { id: 1, name: 'XS' },
      { id: 2, name: 'S' },
      { id: 3, name: 'M' },
      { id: 4, name: 'L' },
      { id: 5, name: 'XL' },
    ],
    rows: [
      { id: 1, name: 'size_data_old.pants.rows.waist' },
      { id: 2, name: 'size_data_old.pants.rows.hips' },
      { id: 3, name: 'size_data_old.pants.rows.weight' },
      { id: 4, name: 'size_data_old.pants.rows.height' },
    ],
    matrix: [
      { rowId: 1, columnId: 1, value: '58-64' },
      { rowId: 1, columnId: 2, value: '65-71' },
      { rowId: 1, columnId: 3, value: '72-77' },
      { rowId: 1, columnId: 4, value: '78-85' },
      { rowId: 1, columnId: 5, value: '86-94' },
      { rowId: 2, columnId: 1, value: '80-84' },
      { rowId: 2, columnId: 2, value: '85-89' },
      { rowId: 2, columnId: 3, value: '90-94' },
      { rowId: 2, columnId: 4, value: '95-99' },
      { rowId: 2, columnId: 5, value: '100-104' },
      { rowId: 3, columnId: 1, value: '40-45' },
      { rowId: 3, columnId: 2, value: '45-50' },
      { rowId: 3, columnId: 3, value: '50-55' },
      { rowId: 3, columnId: 4, value: '55-60' },
      { rowId: 3, columnId: 5, value: '60-65' },
      { rowId: 4, columnId: 1, value: '155-160' },
      { rowId: 4, columnId: 2, value: '160-165' },
      { rowId: 4, columnId: 3, value: '165-169' },
      { rowId: 4, columnId: 4, value: '169-172' },
      { rowId: 4, columnId: 5, value: '172-175' },
    ],
  },
}

export const DEMAND_OPTIONS = [
  {
    label: 'product_detail.size_chart.constants.demand_options.running',
    value: '67bfcb2f10f9da73764d6986',
  },
  {
    label: 'product_detail.size_chart.constants.demand_options.sports',
    value: '67bfcad322460c30a43d192b',
  },
  {
    label: 'product_detail.size_chart.constants.demand_options.yoga_pilates',
    value: '67bfc94aa65c8e57d6390f14',
  },
]
